import React from 'react';
import { HTMLDivAttributesWithRef } from 'domain/models/shared.model';
import Footer from './Footer';
import Header from './Header';
import styles from './LayoutDefault.module.css';

export type LayoutDefaultProps = HTMLDivAttributesWithRef;

// eslint-disable-next-line react/prop-types
const LayoutDefault = React.forwardRef<HTMLDivElement, LayoutDefaultProps>(
  ({ className, children, ...props }, ref): JSX.Element | null => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div {...props} ref={ref} className={`${styles.root} ${className}`}>
      <Header />
      <div className={styles.container}>{children}</div>
      <Footer />
    </div>
  )
);

export default LayoutDefault;
